
import { Component, DestroyRef, inject, OnInit, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { of, switchMap, take } from 'rxjs';
import { CustomerFilter } from 'src/app/common/CustomerFilter';
import { CustomerGroup } from 'src/app/common/CustomerGroup';
import { CustomerGroupService } from 'src/app/services/customergroup.service';
import { AppProfileService } from 'src/app/services/profile.service';
import { isDefaultFilter } from 'src/app/common/filter-state';
import { FilterCardComponent } from '../filter-card/filter-card.component';

@Component({
    imports: [FormsModule, KENDO_DROPDOWNS, FilterCardComponent],
    selector: 'app-customer-search-box',
    templateUrl: './customer-search-box.component.html'
})
export class CustomerSearchBoxComponent implements OnInit {
  private customerGroupService = inject(CustomerGroupService);
  private profileService = inject(AppProfileService);

  private destroyRef = inject(DestroyRef);

  customerGroups: CustomerGroup[];
  searchWord: string = '';
  customerGroupId?: string = null;
  defaultItem: CustomerGroup = { id: null, shortName: '', name: $localize`Alle Kundengruppen` };

  readonly searchCriteria = output<CustomerFilter>();

  /** What the page opened with — the yardstick for the reset button (#228). */
  private readonly defaults = { searchWord: '', customerGroupId: null as string };

  public get isFiltered(): boolean {
    return !isDefaultFilter(
      { searchWord: this.searchWord, customerGroupId: this.customerGroupId },
      this.defaults
    );
  }

  public resetFilter(): void {
    this.searchWord = this.defaults.searchWord;
    this.customerGroupId = this.defaults.customerGroupId;
    this.searchThis();
  }

  searchThis() {
    this.searchCriteria.emit(new CustomerFilter(this.searchWord, this.customerGroupId));
  }

  // #199: this read the unset `recursiveItem` of a „Kundenstamm" dropdown that never rendered,
  // threw, and so never searched — the customer-group filter had no effect at all.
  public customerGroupChange(value: CustomerGroup): void {
    this.searchCriteria.emit(new CustomerFilter(this.searchWord, value?.id));
  }

  ngOnInit(): void {
    // Customer groups are carrier data — the BFF answers 403 for anyone else (#199), and only a
    // carrier gets a customer list to filter in the first place.
    this.profileService.currentProfile$
      .pipe(
        take(1),
        switchMap((p) => (p?.isCarrier ? this.customerGroupService.get() : of<CustomerGroup[]>([]))),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((groups) => {
        this.customerGroups = groups;
      });
  }
}
